import { crTheme } from '@comicrelief/component-library';
import styled from 'styled-components';
import { FullWidthStyledInput, ReusableStylesFocusVisibleOnWrapper, ReusableStylesHideInputElement } from '../../components/global/Global.style';

export const PayInActivityWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin: 30px 0;

  /* this is using a specified px amount, rather than a defined breakpoint,
  because there is an area between 500px and our M breakpoint, where
  these buttons look comically large */
  @media (min-width: 500px) {
    grid-template-columns: repeat(3, 1fr);
    > *:last-child:nth-child(3n-2) {
      grid-column: 2; /* Center in the middle column, if it's the only one on the row */
    }
  }
`;

export const PayInActivityCheckboxLabel = styled.label<{
  $isChecked: boolean;
  $errorState: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${({ $isChecked }) => ($isChecked ? crTheme.color('blue_donate') : crTheme.color('white'))};
  color: ${({ $isChecked }) => ($isChecked ? crTheme.color('white') : crTheme.color('black'))};
  outline: 1px solid
    ${({ $errorState }) => ($errorState ? crTheme.color('red') : crTheme.color('grey'))};
  padding: 16px;
  border-radius: 0.5rem;
  gap: 8px;
  text-align: center;
  line-height: 18px;
  font-weight: bold;
  font-family: Montserrat, Impact, sans-serif;
  cursor: pointer;

    &:focus-within {
    /* Add focus styles when the hidden checkbox is focused */
    outline: 2px solid ${crTheme.color('blue_donate')};
    outline-offset: 2px;
  }

  p {
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 100%;
    height: auto;
  }

  ${ReusableStylesFocusVisibleOnWrapper}
`;

export const PayInActivityCheckbox = styled.input.attrs({ type: 'checkbox' })`
  ${ReusableStylesHideInputElement}
`;

export const PayInActivityOtherInput = styled(FullWidthStyledInput)`
  border-top: 1px solid ${crTheme.color('grey_medium')};
  padding-top: 16px;
  margin-top: 16px;
`;

export const PayInActivityInformationalTextContainer = styled.div<{
  $errorState: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
`;
